import useToggle from '@alltrails/shared/hooks/useToggle';
import { ComponentProps } from 'react';
import AdInterstitialPortal from '../AdInterstitialPortal';

type Props = {
  adId: string;
  adUnitPath: ComponentProps<typeof AdInterstitialPortal>['adUnitPath'];
  experiment: ComponentProps<typeof AdInterstitialPortal>['experiment'];
};

// https://www.figma.com/file/3dCQyKmNlOdfjaZ8vsDpzs/Native-Ads?node-id=471%3A191932&t=UklpU4oVdCjBcrsQ-4
export default function AdInterstitial({ adId, adUnitPath, experiment }: Props) {
  const [isOpen, toggle] = useToggle(true);

  if (!isOpen) {
    return null;
  }

  return <AdInterstitialPortal adId={adId} adUnitPath={adUnitPath} experiment={experiment} toggle={toggle} />;
}
